/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthDemoRouteImport } from './routes/_auth/demo'
import { Route as AuthLocationsIndexRouteImport } from './routes/_auth/locations.index'
import { Route as AuthScenariosIndexRouteImport } from './routes/_auth/scenarios.index'
import { Route as AuthScenariosScenarioIdRouteImport } from './routes/_auth/scenarios.$scenarioId'
import { Route as AuthScenariosNewRouteImport } from './routes/_auth/scenarios.new'
import { Route as AuthSessionsIndexRouteImport } from './routes/_auth/sessions.index'
import { Route as AuthSessionsSessionIdRouteImport } from './routes/_auth/sessions.$sessionId'
import { Route as AuthUsersIndexRouteImport } from './routes/_auth/users.index'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDemoRoute = AuthDemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLocationsIndexRoute = AuthLocationsIndexRouteImport.update({
  id: '/locations/',
  path: '/locations/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthScenariosIndexRoute = AuthScenariosIndexRouteImport.update({
  id: '/scenarios/',
  path: '/scenarios/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthScenariosScenarioIdRoute = AuthScenariosScenarioIdRouteImport.update({
  id: '/scenarios/$scenarioId',
  path: '/scenarios/$scenarioId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthScenariosNewRoute = AuthScenariosNewRouteImport.update({
  id: '/scenarios/new',
  path: '/scenarios/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSessionsIndexRoute = AuthSessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSessionsSessionIdRoute = AuthSessionsSessionIdRouteImport.update({
  id: '/sessions/$sessionId',
  path: '/sessions/$sessionId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersIndexRoute = AuthUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/demo': typeof AuthDemoRoute
  '/scenarios/$scenarioId': typeof AuthScenariosScenarioIdRoute
  '/scenarios/new': typeof AuthScenariosNewRoute
  '/sessions/$sessionId': typeof AuthSessionsSessionIdRoute
  '/locations/': typeof AuthLocationsIndexRoute
  '/scenarios/': typeof AuthScenariosIndexRoute
  '/sessions/': typeof AuthSessionsIndexRoute
  '/users/': typeof AuthUsersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/demo': typeof AuthDemoRoute
  '/': typeof AuthIndexRoute
  '/scenarios/$scenarioId': typeof AuthScenariosScenarioIdRoute
  '/scenarios/new': typeof AuthScenariosNewRoute
  '/sessions/$sessionId': typeof AuthSessionsSessionIdRoute
  '/locations': typeof AuthLocationsIndexRoute
  '/scenarios': typeof AuthScenariosIndexRoute
  '/sessions': typeof AuthSessionsIndexRoute
  '/users': typeof AuthUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/demo': typeof AuthDemoRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/scenarios/$scenarioId': typeof AuthScenariosScenarioIdRoute
  '/_auth/scenarios/new': typeof AuthScenariosNewRoute
  '/_auth/sessions/$sessionId': typeof AuthSessionsSessionIdRoute
  '/_auth/locations/': typeof AuthLocationsIndexRoute
  '/_auth/scenarios/': typeof AuthScenariosIndexRoute
  '/_auth/sessions/': typeof AuthSessionsIndexRoute
  '/_auth/users/': typeof AuthUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/demo'
    | '/scenarios/$scenarioId'
    | '/scenarios/new'
    | '/sessions/$sessionId'
    | '/locations/'
    | '/scenarios/'
    | '/sessions/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/demo'
    | '/'
    | '/scenarios/$scenarioId'
    | '/scenarios/new'
    | '/sessions/$sessionId'
    | '/locations'
    | '/scenarios'
    | '/sessions'
    | '/users'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/_auth/demo'
    | '/_auth/'
    | '/_auth/scenarios/$scenarioId'
    | '/_auth/scenarios/new'
    | '/_auth/sessions/$sessionId'
    | '/_auth/locations/'
    | '/_auth/scenarios/'
    | '/_auth/sessions/'
    | '/_auth/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/demo': {
      id: '/_auth/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof AuthDemoRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/locations/': {
      id: '/_auth/locations/'
      path: '/locations'
      fullPath: '/locations/'
      preLoaderRoute: typeof AuthLocationsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/scenarios/': {
      id: '/_auth/scenarios/'
      path: '/scenarios'
      fullPath: '/scenarios/'
      preLoaderRoute: typeof AuthScenariosIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/scenarios/$scenarioId': {
      id: '/_auth/scenarios/$scenarioId'
      path: '/scenarios/$scenarioId'
      fullPath: '/scenarios/$scenarioId'
      preLoaderRoute: typeof AuthScenariosScenarioIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/scenarios/new': {
      id: '/_auth/scenarios/new'
      path: '/scenarios/new'
      fullPath: '/scenarios/new'
      preLoaderRoute: typeof AuthScenariosNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sessions/': {
      id: '/_auth/sessions/'
      path: '/sessions'
      fullPath: '/sessions/'
      preLoaderRoute: typeof AuthSessionsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sessions/$sessionId': {
      id: '/_auth/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/sessions/$sessionId'
      preLoaderRoute: typeof AuthSessionsSessionIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/': {
      id: '/_auth/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthUsersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthDemoRoute: typeof AuthDemoRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthScenariosScenarioIdRoute: typeof AuthScenariosScenarioIdRoute
  AuthScenariosNewRoute: typeof AuthScenariosNewRoute
  AuthSessionsSessionIdRoute: typeof AuthSessionsSessionIdRoute
  AuthLocationsIndexRoute: typeof AuthLocationsIndexRoute
  AuthScenariosIndexRoute: typeof AuthScenariosIndexRoute
  AuthSessionsIndexRoute: typeof AuthSessionsIndexRoute
  AuthUsersIndexRoute: typeof AuthUsersIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthDemoRoute: AuthDemoRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthScenariosScenarioIdRoute: AuthScenariosScenarioIdRoute,
  AuthScenariosNewRoute: AuthScenariosNewRoute,
  AuthSessionsSessionIdRoute: AuthSessionsSessionIdRoute,
  AuthLocationsIndexRoute: AuthLocationsIndexRoute,
  AuthScenariosIndexRoute: AuthScenariosIndexRoute,
  AuthSessionsIndexRoute: AuthSessionsIndexRoute,
  AuthUsersIndexRoute: AuthUsersIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
